<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 9V19.5C6 20 6.4 20.5 7 20.5H17C17.5 20.5 18 20 18 19.5V9M12 5.5V3.5M10.5 3.5H13.5M4 7.5H20L18.6 5.5H5.4L4 7.5Z"
      class="stroke-current"
    />
  </svg>
</template>
